<template>
	<div v-if="getAuthenticatedUserGroupLevel === '1'">
		<BaseHeader :title="$t('edit_rental_car').toString()" />

		<RentalCarForm :edit-mode="true" />
	</div>
	<Forbidden v-else />
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import RentalCarForm from '@/components/rentalcars/forms/RentalCarForm';
import Forbidden from '@/views/default/Forbidden.vue';
export default {
	name: 'RentalCarEdit',
	components: { Forbidden, RentalCarForm, BaseHeader },
	computed: {
		getAuthenticatedUserGroupLevel() {
			return this.$store.getters.getAuthenticatedUserGroupLevel;
		},
	},
};
</script>

<style scoped></style>
